import { gql } from '@apollo/client';

export const NOW_QUERY = gql`
  query Now {
    now
  }
`;
